import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts'
import type { UsageDataPoint } from '../../lib/types'

interface Props {
  data: UsageDataPoint[]
}

export default function UsageChart({ data }: Props) {
  if (data.length === 0) {
    return <p className="text-text-muted text-sm">No usage data available.</p>
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" />
        <XAxis
          dataKey="period"
          tick={{ fill: 'var(--color-text-secondary)', fontSize: 12 }}
          tickLine={false}
        />
        <YAxis
          tick={{ fill: 'var(--color-text-secondary)', fontSize: 12 }}
          tickLine={false}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: 'var(--color-elevated)',
            border: '1px solid var(--color-surface)',
            borderRadius: 8,
            color: 'var(--color-text-primary)',
          }}
        />
        <Legend />
        <Bar dataKey="exchanges" fill="#6366f1" radius={[4, 4, 0, 0]} />
        <Bar dataKey="ingestions" fill="#f59e0b" radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  )
}
